export default {
  '角色列表':'角色列表',
  '角色名模糊搜索':'角色名模糊搜尋',
  '新增角色':'新增角色',
  '管理成员':'管理成員',
  '角色名称':'角色名稱',
  '角色备注':'角色備註',
  '身份':'身份',
  '成员数量':'成員數量',
  '确认要删除该角色：{roleName}？':'確認要刪除該角色：{roleName}？',
  '角色类型':'角色類型',
  '请输入角色名称,仅支持中英文、数字':'請輸入角色名稱，僅支援中英文、數字',
  '功能权限':'功能權限',
  '移动端':'移動端',
  '编辑角色':'編輯角色',
  '角色名称仅支持中英文、数字':'角色名稱僅支援中英文、數字',
  '成功！':'成功！',
  '新增成员':'新增成員',
  '取消全部选中':'取消全部選中',
  '是否确认批量移除{length}名成员？':'是否確認批量移除{length}名成員？',
  '批量移除成功':'批量移除成功',
  '是否确认移除成员{accountName}？':'是否確認移除成員{accountName}？',
  '移除成功':'移除成功',
  '请输入用户名称':'請輸入用戶名稱',
  '新增成员成功!':'新增成員成功！',
  '已选中{selectedCount}人':'已選中{selectedCount}人',

  //25-8-4
  '操作成功':'操作成功',
}    